import { useState, useContext } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

// @mui icons
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Images
import brandLogo from "assets/images/efta_logo.svg";

import { authenticateUser } from "services/authService";
import { UserContext } from "context/UserContext";
import { useNavigate } from "react-router-dom";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { setUser } = useContext(UserContext);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const navigate = useNavigate();
  const coreRoles = ["ROLE_MANAGER", "ROLE_SALES_RESPONSIBLE", "ROLE_CUSTOMER"];

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSignIn = async () => {
    try {
      const login = await authenticateUser(username, password, setUser);
      if (!login.success) {
        return;
      }
      const roles = Array.isArray(login.data?.roles) ? login.data.roles : [];
      const hasCoreRole = roles.some((role) => coreRoles.includes(role));
      navigate(hasCoreRole ? "/orders/create" : "/demand", { replace: true });
    } catch (error) {
      toast.error("Giriş başarısız oldu", { position: "top-right" });
    }
  };

  return (
    <BasicLayout>
      <Card>
        <MDBox pt={4} pb={3} px={3} textAlign="center">
          <MDBox
            component="img"
            src={brandLogo}
            alt="EFTA Tuz"
            width="16rem"
            mb={2}
            sx={{ display: "block", marginInline: "auto" }}
          />
          <MDTypography variant="h5" fontWeight="medium" color="dark">
            Giriş Yap
          </MDTypography>
        </MDBox>
        <MDBox pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="E-posta"
                fullWidth
                value={username}
                onChange={(e) => setUserName(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type={showPassword ? "text" : "password"}
                label="Şifre"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Beni hatırla
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth onClick={handleSignIn}>
                GİRİŞ YAP
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
